/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Petstore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Autorip
 */
export interface Autorip {
    /**
     * 
     * @type {string}
     * @memberof Autorip
     */
    'PhysicalASIN': string;
    /**
     * 
     * @type {string}
     * @memberof Autorip
     */
    'Territory': string;
}
/**
 * 
 * @export
 * @interface AutoripResults
 */
export interface AutoripResults {
    /**
     * 
     * @type {string}
     * @memberof AutoripResults
     */
    'PhysicalASIN': string;
    /**
     * 
     * @type {string}
     * @memberof AutoripResults
     */
    'Territory': string;
    /**
     * 
     * @type {string}
     * @memberof AutoripResults
     */
    'Result': string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {number}
     * @memberof ModelError
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
}

/**
 * AutoripSelfServiceApi - axios parameter creator
 * @export
 */
export const AutoripSelfServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check Autorip for a specific Physical ASIN in specific territory
         * @param {Autorip} autorip Get Service Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoripChecker: async (autorip: Autorip, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autorip' is not null or undefined
            assertParamExists('autoripChecker', 'autorip', autorip)
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autorip, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get result for the autorip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoripRetriever: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutoripSelfServiceApi - functional programming interface
 * @export
 */
export const AutoripSelfServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutoripSelfServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check Autorip for a specific Physical ASIN in specific territory
         * @param {Autorip} autorip Get Service Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoripChecker(autorip: Autorip, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Autorip>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoripChecker(autorip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get result for the autorip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async autoripRetriever(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Autorip>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.autoripRetriever(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AutoripSelfServiceApi - factory interface
 * @export
 */
export const AutoripSelfServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutoripSelfServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Check Autorip for a specific Physical ASIN in specific territory
         * @param {Autorip} autorip Get Service Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoripChecker(autorip: Autorip, options?: any): AxiosPromise<Autorip> {
            return localVarFp.autoripChecker(autorip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get result for the autorip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        autoripRetriever(options?: any): AxiosPromise<Autorip> {
            return localVarFp.autoripRetriever(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AutoripSelfServiceApi - object-oriented interface
 * @export
 * @class AutoripSelfServiceApi
 * @extends {BaseAPI}
 */
export class AutoripSelfServiceApi extends BaseAPI {
    /**
     * 
     * @summary Check Autorip for a specific Physical ASIN in specific territory
     * @param {Autorip} autorip Get Service Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoripSelfServiceApi
     */
    public autoripChecker(autorip: Autorip, options?: AxiosRequestConfig) {
        return AutoripSelfServiceApiFp(this.configuration).autoripChecker(autorip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get result for the autorip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutoripSelfServiceApi
     */
    public autoripRetriever(options?: AxiosRequestConfig) {
        return AutoripSelfServiceApiFp(this.configuration).autoripRetriever(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CORSApi - axios parameter creator
 * @export
 */
export const CORSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Enable CORS by returning correct headers 
         * @summary CORS support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootOptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CORSApi - functional programming interface
 * @export
 */
export const CORSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CORSApiAxiosParamCreator(configuration)
    return {
        /**
         * Enable CORS by returning correct headers 
         * @summary CORS support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootOptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CORSApi - factory interface
 * @export
 */
export const CORSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CORSApiFp(configuration)
    return {
        /**
         * Enable CORS by returning correct headers 
         * @summary CORS support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootOptions(options?: any): AxiosPromise<void> {
            return localVarFp.rootOptions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CORSApi - object-oriented interface
 * @export
 * @class CORSApi
 * @extends {BaseAPI}
 */
export class CORSApi extends BaseAPI {
    /**
     * Enable CORS by returning correct headers 
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CORSApi
     */
    public rootOptions(options?: AxiosRequestConfig) {
        return CORSApiFp(this.configuration).rootOptions(options).then((request) => request(this.axios, this.basePath));
    }
}


